// extracted by mini-css-extract-plugin
export default {"wrapper":"ui_wrapper__RCEV1","wrapperLoader":"ui_wrapperLoader__AQIdK"};